import type { Village } from "@/types/MassterData/village";
import { ChevronDown } from "lucide-react";

export const NAV_ITEMS = (villageList: Village[] = []) => [
  {
    key: "1",
    label: "Utama",
  },
  {
    key: "2",
    label: (
      <span className="inline-flex items-center gap-1 group">
        Mengikut Kampung
        <ChevronDown
          className="group-hover:rotate-180 transition-transform duration-200 ease-out"
          size={16}
          aria-hidden="true"
        />
      </span>
    ),
    children: [
      ...villageList.map((village) => ({
        key: `village/${village.mdVillageId}`,
        label: village.name,
      })),
    ],
  },
  {
    key: "3",
    label: "Permohonan Belum Diproses",
  },
  {
    key: "4",
    label: "Semua Permohonan",
  },
  {
    key: "5",
    label: "Permohonan Ditolak",
  },
];

export const NAV_PROFILE = [
  {
    key: "6",
    label: <span style={{ fontWeight: 500 }}>Tukar Kata Laluan</span>,
  },
  {
    key: "7",
    label: <span style={{ fontWeight: 500 }}>Log Keluar</span>,
  },
];
